import React from 'react';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import { Atons } from './Atons';

export const MapAtons = React.memo(({ className }: { className: string }) => {
  const onExit = useOnMapPanelExit();

  return <Atons className={className} onExit={onExit} requiresMap={true} />;
});
